import { z } from 'zod'

export const automationSetupCardSchema = z.object({
  automation_id: z.string(),
  title: z.string(),
  status: z.enum(['draft', 'invalid']).catch('draft'),
  surface: z.enum(['create_schedule', 'create_event_trigger', 'create_manual_automation']),
  trigger_count: z.number().optional(),
  approval_required: z.boolean().optional(),
  error: z.string().optional(),
})
